import { CommandJob } from "~/components/build/Show/lib/types";
import { CommandStep } from "~/lib/pipeline";
import { JobCount, StatsJobCount } from "~/components/build/Show/components/StatsJobCount";

interface Props {
  jobs: CommandJob[];
  step: CommandStep;
}

export function Jobs({ jobs, step }: Props) {
  return (
    <span className="text-charcoal-300">
      {Features.BuildSidebar ? <StatsJobCount step={step} /> : <JobCount jobs={jobs} step={step} />}
    </span>
  );
}
